export default {
  title: 'Don’t miss out!',
  description: 'Turn on notifications to stay updated on your order.',
  buttons: {
    enable: 'Enable',
  },
};
